import "@/App.css";
import { useEffect, useRef } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "sonner";
import Analytics from "@/components/site/Analytics";
import Home from "@/pages/Home";
import Login from "@/pages/Login";
import Admin from "@/pages/Admin";
import Privacy from "@/pages/Privacy";
import Success from "@/pages/Success";
import PowerThePaddle from "@/pages/PowerThePaddle";
import ClinicSuccess from "@/pages/ClinicSuccess";
import AdminClinics from "@/pages/AdminClinics";
import { initTheme } from "@/lib/theme";

function App() {
  const lenisRef = useRef(null);

  useEffect(() => {
    initTheme();
    const id = setInterval(() => {
      const inst = lenisRef.current?.lenis;
      if (inst) {
        window.__lenis = inst;
        clearInterval(id);
      }
    }, 100);
    return () => clearInterval(id);
  }, []);

  return (
    <div className="App dark bg-background text-foreground">
      <Analytics />
      <div className="noise-overlay" />
      <Toaster
        theme="dark"
        position="top-center"
        toastOptions={{
          style: {
            background: "#111111",
            border: "1px solid #222222",
            borderRadius: 0,
            color: "#fff",
            fontFamily: "Manrope, sans-serif",
          },
        }}
      />
      <BrowserRouter>
        <ReactLenis root ref={lenisRef}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/success" element={<Success />} />
            <Route path="/clinics/:slug" element={<PowerThePaddle />} />
            <Route path="/clinics/:slug/success" element={<ClinicSuccess />} />
            <Route path="/admin/clinics" element={<AdminClinics />} />
          </Routes>
        </ReactLenis>
      </BrowserRouter>
    </div>
  );
}

export default App;
